import React, { useEffect, useState } from "react";
import "./ModuleListCard.scss";
import GreenTickMark from "../../../images/Final-Status.svg";
import EmptyImage from "../../../images/EmptyImage.svg";
import NotApprovedImage from "../../../images/not-approved-image.svg";
import time from "../../../images/time.svg";
import CannotExitImage from "../../../images/Cannotexist.svg";

import BlueCheckBox from "../../../images/bluecheckbox.svg";
import MustExist from "../../../images/MustExist.svg";
import CustomTooltip from "../../Tooltip/Tooltip";

const ModuleListCard = (props) => {
  const {
    moduleList,
    handleViewClick,
    handleCardClick,
    selectedNextModuleList,
    selectedModuleIds,
    getModuleStyle,
    disabledModules,
    disabledMustExistModules,
  } = props;

  const getTimeDetails = (time) => {
    const date = new Date(time);
    const currentDate = new Date();
    const diffInMilliseconds = currentDate - date;
    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
    return diffInDays > 0 ? `${diffInDays} Days ago` : "Today";
  };

  const greenCheckmark = (
    <img src={BlueCheckBox} alt="" className="module-list-selected-image" />
  );

  // Red Cross SVG
  const redCross = (
    <img src={CannotExitImage} alt="" className="module-list-selected-image" />
  );

  const yellowTick = (
    <img src={MustExist} alt="" className="module-list-selected-image" />
  );

  const getBackGroudColor = () => {
    if (selectedModuleIds?.includes(moduleList?.id)) {
      return "module-list-card-content-green-bg";
    } else if (disabledModules.includes(moduleList.id)) {
      return "module-list-card-content-red-bg";
    } else if (disabledMustExistModules.includes(moduleList.id)) {
      return "module-list-card-content-dark-green-bg";
    }
  };

  const getColor = (status) => {
    if (status === "Approved for Use" || "Available for Use") return "#E1EDDA";
    if (status === ("Draft" || "Expired" || "Withdrawn")) return "#F0F0F0";
    if (status === ("In Business Owner Review" || "Approval Complete" || "Librarian QC")) return "#FDE9DF";
    return "";
  };

  return (
    <div
      key={moduleList?.id}
      className={`${getModuleStyle(moduleList.id)} module-list-card-main d-flex ${
        disabledMustExistModules.includes(moduleList.id)
          ? "module-list-card-main-selected-dark"
          : ""
      } ${
        selectedModuleIds?.includes(moduleList?.id)
          ? "module-list-card-main-selected"
          : ""
      }`}
      onClick={(e) => handleCardClick(moduleList?.id, moduleList.moduleBusinessRules, moduleList)}
      // style={getModuleStyle(moduleList.id)}
    >
      <div className="module-list-card-content">
        {selectedModuleIds?.includes(moduleList?.id) && greenCheckmark}
        {disabledModules.includes(moduleList.id) && redCross}
        {disabledMustExistModules.includes(moduleList.id) && yellowTick}
        {moduleList?.componentUrl ? (
          <div className="module-list-card-img-content">
            <img src={moduleList?.componentUrl} alt="" className="img-fluid" />
          </div>
        ) : (
          <div className="module-list-card-img-not-found-content">
            <img src={EmptyImage} alt="" className="img-fluid" />
          </div>
        )}
        <div className={`module-list-card-content-list ${getBackGroudColor()}`}>
          <div className="d-flex align-items-center">
            <div className="d-flex align-items-center" style={{ backgroundColor: getColor(moduleList?.mlrStatus), borderRadius: "6px", padding: "3px 12px" }}>
              <img
                src={
                  moduleList?.mlrStatus === "Available for Use"
                    ? GreenTickMark
                    : NotApprovedImage
                }
                alt=""
              />
              <p className="module-list-card-moduleName">
                {moduleList?.moduleDamName}
              </p>
            </div>
          </div>

          <div className="d-flex align-items-center module-card-brand-details">
            <h4 className="module-list-card-brand-name">Product: </h4>
            {/* <h2 className='module-list-card-brand-content'>{moduleList?.productName}</h2> */}
            <CustomTooltip
              title={moduleList?.productName}
              classes="module-list-card-brand-name-tooltip"
            >
              <h2 className="module-list-card-brand-content" style={{width: '63px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                {moduleList?.productName}
              </h2>
            </CustomTooltip>

            <h4 className="module-list-card-brand-name">Country: </h4>
            {/* <h2 className='module-list-card-brand-content'>{moduleList?.productName}</h2> */}
            <CustomTooltip
              title={moduleList?.countryName}
              classes="module-list-card-brand-name-tooltip"
            >
              <h2 className="module-list-card-brand-content" style={{width: '63px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                {moduleList?.countryName}
              </h2>
            </CustomTooltip>
          </div>

          <div className="d-flex align-items-center module-card-brand-details">
            <h4 className="module-list-card-brand-name">Name: </h4>
            {/* <h2 className='module-list-card-brand-content'>{moduleList?.productName}</h2> */}
            <CustomTooltip
              title={moduleList?.moduleName}
              classes="module-list-card-brand-name-tooltip"
            >
              <h2 className="module-list-card-brand-content">
                {moduleList?.moduleName}
              </h2>
            </CustomTooltip>
          </div>
          <div className="d-flex align-items-center justify-content-between">
            <h2 className="d-flex align-items-center module-list-card-created-at">
              <img src={time} alt="image" />
              <h4>{getTimeDetails(moduleList?.editedDateTime)}</h4>
            </h2>
            <button
              className="module-list-card-view"
              onClick={(e) => handleViewClick(e, moduleList)}
            >
              VIEW
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModuleListCard;
